import React from 'react';
import Image from 'next/image';
import leftArrowNext from '../../svgs/left_arrow_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function LeftArrowWhiteNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={`invert ${className}`}
      src={leftArrowNext}
      alt={alt ?? 'Til venstre'}
    />
  );
}
